/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkPackage } from './WorkPackage';
import {
    WorkPackageFromJSON,
    WorkPackageFromJSONTyped,
    WorkPackageToJSON,
} from './WorkPackage';

/**
 * 
 * @export
 * @interface WorkPackagesResponse
 */
export interface WorkPackagesResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkPackagesResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPackagesResponse
     */
    projectId: string;
    /**
     * 
     * @type {Array<WorkPackage>}
     * @memberof WorkPackagesResponse
     */
    workPackages: Array<WorkPackage>;
    /**
     * 
     * @type {any}
     * @memberof WorkPackagesResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the WorkPackagesResponse interface.
 */
export function instanceOfWorkPackagesResponse(value: object): value is WorkPackagesResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('workPackages' in value) || value['workPackages'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function WorkPackagesResponseFromJSON(json: any): WorkPackagesResponse {
    return WorkPackagesResponseFromJSONTyped(json, false);
}

export function WorkPackagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPackagesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'projectId': json['projectId'],
        'workPackages': ((json['workPackages'] as Array<any>).map(WorkPackageFromJSON)),
        'count': json['count'],
    };
}

export function WorkPackagesResponseToJSON(value?: WorkPackagesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'projectId': value['projectId'],
        'workPackages': ((value['workPackages'] as Array<any>).map(WorkPackageToJSON)),
        'count': value['count'],
    };
}

